module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.entity) ? _c('div', {
    staticClass: "component-reservation-action-buttons"
  }, [(_vm.item) ? _c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#Item-1"
    }
  }, [_vm._v("Action")]), _c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Open")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])]), _c('li', [_c('PreauthReveal', {
    attrs: {
      "reservation": _vm.entity
    }
  })], 1), _c('li', [_c('TerminateReservationReveal', {
    attrs: {
      "entity": _vm.entity
    }
  })], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.extend
    }
  }, [_vm._v("Extend")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.voidR
    }
  }, [_vm._v("Void")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("Force Resend")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.cleanup
    }
  }, [_vm._v("Cleanup")])]), _c('li', [_c('ChargingSessionReveal', {
    attrs: {
      "reservation": _vm.entity
    }
  })], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: 'report-reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("Report")])], 1), _c('li', [_c('ActionButton', {
    attrs: {
      "action": _vm.reconciliate
    }
  }, [_c('a', [_vm._v("Reconciliate charged cost")])])], 1), _c('li', [_c('ActionButton', {
    attrs: {
      "action": _vm.complete,
      "saveLabel": "Mark as completed"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "prompt"
    },
    slot: "prompt"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Mark R" + _vm._s(_vm.entity.number) + " as completed")]), _c('label', [_vm._v("Strategy"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.strategy),
      expression: "strategy"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.strategy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "original_end"
    }
  }, [_vm._v("End as the booked end")]), _c('option', {
    attrs: {
      "value": "first_end_sent"
    }
  }, [_vm._v("First end sent")]), _c('option', {
    attrs: {
      "value": "user_defined"
    }
  }, [_vm._v("Custom")])])]), (_vm.strategy === 'user_defined') ? _c('div', {
    staticClass: "user-defined"
  }, [_c('label', [_vm._v("Select Date")]), _c('DatePicker', {
    attrs: {
      "pickTime": true,
      "format": "yyyy-mm-dd hh:ii"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1) : _vm._e(), (_vm.entity.booking_mode === 'OWFF') ? [_c('label', [_vm._v("End on selected parking lot")]), _c('SelectizeParkingLot', {
    model: {
      value: (_vm.extra.owff_dropoff_parking_lot),
      callback: function($$v) {
        _vm.$set(_vm.extra, "owff_dropoff_parking_lot", $$v)
      },
      expression: "extra.owff_dropoff_parking_lot"
    }
  })] : _vm._e()], 2)]), _c('a', [_vm._v("Mark as completed")])])], 1), _c('li', [_c('a', {
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")])]), _c('li', [_c('a', {
    on: {
      "click": _vm.findReplace
    }
  }, [_vm._v("Find a replace vehicle")])]), (_vm.entity.maintenance) ? _c('li', [_c('ModalReveal', [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Replace operator")]), _c('h2', [_vm._v("Replace operator")]), _c('selectize-maintenance-driver', {
    attrs: {
      "value-field": "id"
    },
    model: {
      value: (_vm.replaceDriverBody.driver_id),
      callback: function($$v) {
        _vm.$set(_vm.replaceDriverBody, "driver_id", $$v)
      },
      expression: "replaceDriverBody.driver_id"
    }
  }), _c('ActionButton', {
    attrs: {
      "action": _vm.save
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()])])]) : _c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('button', {
    staticClass: "button success",
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Open")]), _c('button', {
    staticClass: "button warning",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")]), _c('button', {
    staticClass: "button alert",
    on: {
      "click": _vm.voidR
    }
  }, [_vm._v("Void")]), _c('button', {
    staticClass: "button warning",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "button warning",
    on: {
      "click": _vm.resend
    }
  }, [_vm._v("Force resend")]), _c('ReservationUncoveredAmountReveal')], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b94134a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/ReservationActionButtons.vue
// module id = 2349
// module chunks = 1